/* v034 (31/10) et v038 (03/11/2026) · Pack Découverte 6 jours sur la fiche Challenge (voir claude/pilotage/v038-pack-decouverte-2026-11-03.md). */
(function(){
  var W = window.V34 || {}, P = window.V28P;
  var D = document, H = D.documentElement;
  function $$(s, r){ return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function wlMode(){ return !!(W.wl && !W.cust); }
  var MEALS = {'challenge-100-shakes': [12, '12 shakes'], 'challenge-2-par-jour': [12, '6 shakes et 6 plats'], 'challenge-100-plats-chauds': [12, '12 plats'], 'challenge-3-par-jour': [18, '6 shakes et 12 plats']};
  /* v038 : prix du pack 6 jours par formule, lus sur les cartes Elkad (data-v34-raw), valeurs du 31/10 en secours */
  var PK = {'challenge-100-shakes': ['pack-100-shakes-6-jours', 5990], 'challenge-2-par-jour': ['pack-challenge-6-jours-2-par-jour', 8490], 'challenge-100-plats-chauds': ['pack-plats-6-jours', 8990], 'challenge-3-par-jour': ['pack-challenge-6-jours-3-par-jour', 12690]};
  function packCents(h){
    var k = PK[h]; if (!k) return 0;
    var c = D.querySelector('.elkad-pack-purchase-type[data-v34-6j][data-pack-purchase-type-handle="' + k[0] + '"]'), r = c ? parseInt(c.getAttribute('data-v34-raw'), 10) : 0;
    return r > 0 ? r : k[1];
  }
  function packTxt(h){ var c = packCents(h); return c ? (c % 100 ? (c / 100).toFixed(2).replace('.', ',') : String(c / 100)) : ''; }

  /* Styles */
  var css = '.v34-box{margin:20px 0 6px}' +
    '.v34-box .v34-ey{margin:0 0 8px 2px;font-size:14px;font-weight:700;color:#1d1d1f}' +
    '.v34-box .va-card{width:100%;margin:0;flex-wrap:wrap}' +
    '.v34-box .v34-foot{flex:0 0 100%;margin-top:12px;padding-top:10px;border-top:1px solid rgba(0,0,0,.07);text-align:left}' +
    '.v34-box .v34-gf{display:flex;align-items:center;gap:6px}' +
    '.v34-box .v34-gf img{width:30px;height:30px;object-fit:cover;border-radius:8px;background:#f4efe8;flex:none}' +
    '.v34-box .v34-gf em{margin-left:4px;font-style:normal;font-size:13px;line-height:1.3;color:#3a3a3f}' +
    '.v34-box .v34-note{display:block;margin-top:6px;font-size:12.5px;line-height:1.35;color:#6b6e75;font-weight:400}' +
    '.v34-up{display:inline-block;margin:10px 4px 0;padding:0;border:0;background:none;color:#00885A;font-family:inherit;font-weight:600;font-size:15px;line-height:1.35;text-decoration:underline;text-underline-offset:3px;text-align:left;cursor:pointer}' +
    '.v34-more{display:flex;justify-content:space-between;align-items:center;gap:12px;width:100%;margin:12px 0 0;padding:18px;border:1px solid #e3ded6;border-radius:18px;background:#fff;color:#1d1d1f;font-family:inherit;font-weight:700;font-size:16px;line-height:1.3;text-align:left;cursor:pointer}' +
    '.v34-more small{display:block;margin-top:3px;font-weight:400;font-size:13px;color:#6b6e75}' +
    '.v34-more .v34-chev{flex:none;font-size:24px;line-height:1;color:#E5403A}' +
    '.v34-a{margin-top:8px!important;border:1.25px solid #c3d3ff!important;background:#eef3ff!important;border-radius:14px;position:relative}' +
    '.v34-box.v34-top{margin:16px 0 4px}' +
    '.v34-box .va-du{position:relative;background:#eef3ff;border-color:#c3d3ff}' +
    '.v34-box .va-du.on{background:#e6edff;border-color:#E5403A}' +
    '.v34-tag{position:absolute;top:-11px;right:16px;z-index:2;padding:3px 10px;border-radius:999px;background:#0255FB;color:#fff;font:700 13px/1.35 VaCampton,campton-book,sans-serif;white-space:nowrap}' +
    '.v34-or{margin:18px 0 8px 2px;font-size:14px;font-weight:700;color:#1d1d1f}' +
    '.v34-a-h{margin:18px 0 6px;font-weight:700;font-size:15px}' +
    '.v34-a-n{margin:6px 0 0;font-size:13px;color:#5c5f66}' +
    '.v34-a .elkad-pack-purchase-type__option__header__infos__title{white-space:normal}' +
    '@media (max-width:1023px){.va-main .v34-box{margin-left:16px;margin-right:16px}.va-main .v34-up{margin-left:20px;margin-right:20px}.va-main .v34-more{width:calc(100% - 32px);margin-left:16px;margin-right:16px}.va-main .v34-or{margin-left:18px;margin-right:16px}}';
  var st = D.createElement('style'); st.textContent = css; (D.head || H).appendChild(st);

  /* 2. Prix du pack 6 jours exposé au thème seulement quand il est coché */
  function syncRaw(){
    $$('.elkad-pack-purchase-type[data-v34-6j]').forEach(function(c){
      var i = c.querySelector('input[type="radio"]'), r = c.getAttribute('data-v34-raw');
      if (i && i.checked) { if (r && c.getAttribute('data-raw-price') !== r) c.setAttribute('data-raw-price', r); }
      else if (c.hasAttribute('data-raw-price')) c.removeAttribute('data-raw-price');
    });
  }
  D.addEventListener('click', function(e){
    var c = e.target.closest && e.target.closest('.elkad-pack-purchase-type[data-v34-6j]');
    if (c) { var r = c.getAttribute('data-v34-raw'); if (r) c.setAttribute('data-raw-price', r); }
  }, true);
  D.addEventListener('change', function(e){ if (e.target && e.target.closest && e.target.closest('.elkad-pack-purchase-type')) syncRaw(); }, true);

  function chosen6(){
    return $$('.elkad-pack-purchase-type[data-v34-6j]').filter(function(c){ var i = c.querySelector('input[type="radio"]'); return i && i.checked && c.offsetParent !== null; })[0] || null;
  }

  /* 5. Attribut de panier */
  D.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.elkad-pack-product-form__cta');
    if (!b || !chosen6()) return;
    try { fetch('/cart/update.js', {method: 'POST', keepalive: true, headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {essai_6j: wlMode() ? 'wl' : 'encadre'}})}); } catch (x) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('so_essai_6j_ajout', {entree: wlMode() ? 'wl' : 'encadre'}); } catch (x) {}
  }, true);

  /* Version A (sélecteur Elkad sans le parcours en étapes) : la carte 6 jours devient un encadré à part, en tête pour les visites WL */
  var preA = 0;
  function paintA(){
    if (H.classList.contains('v21')) return;
    $$('.elkad-pack-purchase-type[data-v34-6j]').forEach(function(c){
      var par = c.parentNode; if (!par) return;
      if (!c.getAttribute('data-v34a')) {
        c.setAttribute('data-v34a', '1');
        c.classList.add('v34-a');
        var t = c.querySelector('[class*="__infos__title"]'); if (t) t.textContent = 'Pack Découverte 6 jours';
        if (c.getAttribute('data-pack-purchase-type-handle') === 'pack-100-shakes-6-jours') {
          $$('li', c).forEach(function(li){ if (/Paiement en 3x/i.test(li.textContent)) li.parentNode.removeChild(li); });
          var ul = c.querySelector('ul'); if (ul) { var li = D.createElement('li'); li.textContent = 'Livraison non incluse, offerte dès 60 €'; ul.appendChild(li); }
        }
        var h = D.createElement('p'); h.className = 'v34-a-h'; h.textContent = wlMode() ? 'Pour commencer, pour goûter' : 'Pour goûter avant de vous lancer';
        /* v038 : en tête pour tout le monde, avec l'étiquette « Pour essayer » */
        var tg = D.createElement('span'); tg.className = 'v34-tag'; tg.textContent = 'Pour essayer'; c.appendChild(tg);
        par.insertBefore(c, par.firstChild);
        par.insertBefore(h, c);
      }
    });
    try { if (!H.classList.contains('v21') && wlMode() && !preA) { var c6 = $$('.elkad-pack-purchase-type[data-v34-6j]').filter(function(x){ return x.offsetParent !== null; })[0]; if (c6) { preA = 1; var l = c6.querySelector('label'); if (l) l.click(); } } } catch (x) {}
  }

  /* Version B : écrans du parcours en étapes (V21A.R) */
  function wrapB(){
    var A = window.V21A;
    if (!A || !A.R || A.R.__v34) return !!(A && A.R && A.R.__v34);
    A.R.__v34 = 1;
    function is6(d){ return !!(d && d.inp && d.inp.closest && d.inp.closest('[data-v34-6j]')); }
    function e(s){ return A.esc ? A.esc(s) : s; }
    function num(s){ var m = String(s || '').replace(/\s/g, '').match(/(\d+)(?:,(\d{1,2}))?/); return m ? +(m[1] + '.' + (m[2] || '0')) : 0; }
    function eur(n){ return n.toFixed(2).replace('.', ',') + '&nbsp;€'; }
    function noHw(S, f){
      if (!P || !S || !is6(S.dur)) return f();
      var on = P.on; P.on = function(){ return false; };
      try { return f(); } finally { P.on = on; }
    }
    function box(S, d6, i6, i2, top, gi){
      var h = S.f && S.f.h, on = is6(S.dur), mm = MEALS[h] || [12, '12 repas'], p = num(d6.pr);
      var per = p && mm[0] ? eur(Math.round(p / mm[0] * 100) / 100) + (h === 'challenge-100-shakes' ? ' le shake' : h === 'challenge-100-plats-chauds' ? ' le plat' : ' le repas') : '';
      var gift = h === 'challenge-100-plats-chauds' ? 'Guide et suivi nutrition offerts' : 'Shaker, guide et suivi nutrition offerts';
      var note = h === 'challenge-100-shakes' ? '<span class="v34-note">Livraison non incluse, offerte dès 60&nbsp;€.</span>' : '';
      var th = (gi || []).map(function(u){ return '<img src="' + u + '" alt="" loading="lazy">'; }).join('');
      var out = '<div class="v34-box v34-top' + (on ? ' on' : '') + '">' +
        '<button type="button" class="va-card va-du' + (on ? ' on' : '') + '" data-a="d" data-v="' + i6 + '" aria-pressed="' + on + '"><span class="va-radio"></span><div class="va-dm"><b>Pack Découverte 6&nbsp;jours</b><span>' + mm[1] + '</span><i>Goûtez avant de vous lancer</i></div><div class="va-dp"><b>' + e(d6.pr) + '</b><em>' + per + '</em></div><div class="v34-foot"><span class="v34-gf">' + th + '<em>' + gift + '</em></span>' + note + '</div><span class="v34-tag">Pour essayer</span></button>';
      var d2 = (S.durs || [])[i2], p2 = d2 ? num(d2.pr) : 0;
      if (p2 && P && P.on && P.on() && P.cut) p2 = P.cut(p2);
      var gap = p2 && p ? Math.round((p2 - p) * 100) / 100 : 0;
      if (on && i2 > -1 && gap > 0) out += '<button type="button" class="v34-up" data-a="d" data-v="' + i2 + '">Pour ' + eur(gap) + ' de plus, passez au Challenge 2 semaines</button>';
      return out + '</div>';
    }
    function rd(h){ return typeof h === 'string' ? h.replace('<i>Pour découvrir</i>', '<i>Premiers résultats</i>') : h; }
    var s2 = A.R.s2;
    A.R.s2 = function(S){
      var durs = S && S.durs || [], i6 = -1;
      durs.forEach(function(d, i){ if (i6 < 0 && is6(d)) i6 = i; });
      if (i6 < 0) return rd(s2.apply(this, arguments));
      var map = [], others = [];
      durs.forEach(function(d, i){ if (i !== i6) { map.push(i); others.push(d); } });
      var i2 = -1; durs.forEach(function(d, i){ if (i2 < 0 && /\b2\s*semaines/i.test(d.t || '')) i2 = i; });
      var on6 = is6(S.dur), S2 = {}, k;
      for (k in S) S2[k] = S[k];
      S2.durs = others; S2.dur = on6 ? (durs[i2] || others[0]) : S.dur;
      var wl = wlMode();
      if (wl && !A.ui.v34pre && S.step === 2) {
        A.ui.v34pre = 1;
        if (!on6) setTimeout(function(){ try { A.label(durs[i6].inp).click(); if (A.render) A.render(true); } catch (x) {} }, 0);
      }
      var h = rd(s2.call(this, S2));
      h = h.replace(/data-a="d" data-v="(\d+)"/g, function(m, j){ return 'data-a="d" data-v="' + (map[+j] != null ? map[+j] : j) + '"'; });
      var li = h.indexOf('<div class="va-list">'), gi = h.indexOf('<div class="va-box">', li);
      var gimg = [];
      if (gi > -1) h.slice(gi).replace(/<img src="([^"]+)"[^>]*><b>([^<]*)<\/b>/g, function(m, u, t){ if (/shaker|guide/i.test(t) && gimg.length < 2) gimg.push(u); return m; });
      var b = box(S, durs[i6], i6, i2, wl, gimg), inc = '';
      var d2 = durs[i2], p2 = d2 ? num(d2.pr) : 0;
      if (p2 && P && P.on && P.on() && P.cut) p2 = P.cut(p2);
      var moreBtn = '<button type="button" class="v34-more" data-v34="more"><span>Le Challenge 2, 4 ou 8 semaines<small>' + (p2 ? 'Dès ' + eur(p2) + ', shaker, guide, suivi et livraison offerts' : 'Shaker, guide, suivi et livraison offerts') + '</small></span><span class="v34-chev" aria-hidden="true">›</span></button>';
      if (li < 0) return h + b;
      if (wl) {
        var more = A.ui.v34more || !on6;
        var list = gi > -1 ? h.slice(li, gi) : h.slice(li);
        var rest = gi > -1 ? h.slice(gi) : '';
        if (on6 && !more) rest = inc;
        if (on6 && !more) h = h.replace(/<p class="hw-tag">[\s\S]*?<\/p>/, '');
        li = h.indexOf('<div class="va-list">');
        return h.slice(0, li) + b + (more ? list : moreBtn) + rest;
      }
      /* v038 : pack en tête pour tout le monde, la liste des durées suit (cadeaux du Challenge retirés quand le pack est coché, comme avant) */
      var orl = '<p class="v34-or">Ou le Challenge 2, 4 ou 8 semaines</p>';
      if (gi < 0) return h.slice(0, li) + b + orl + h.slice(li);
      return on6 ? h.slice(0, li) + b + orl + h.slice(li, gi) + inc : h.slice(0, li) + b + orl + h.slice(li);
    };
    /* v038 : « dès » des formules (écran formule et total du côté) au prix du pack 6 jours, remis en place après le rendu */
    function dswap(S){
      var bk = [];
      function nf(x){ var p = packTxt(x && x.h); return p && x.from ? String(x.from).replace(/\d+(?:,\d+)?/, p) : null; }
      function set(o){ var v = nf(o); if (v) { bk.push([o, o.from]); o.from = v; } }
      (S && S.formulas || []).forEach(set);
      if (S && S.f && (S.step === 1 || !S.dur)) set(S.f);
      return function(){ for (var i = bk.length - 1; i >= 0; i--) bk[i][0].from = bk[i][1]; };
    }
    ['s1', 'side', 'go', 'sum', 'top', 'note'].forEach(function(n){
      var f = A.R[n]; if (typeof f !== 'function') return;
      A.R[n] = function(S){
        var back = dswap(S), h;
        try { h = f.apply(this, arguments); } finally { back(); }
        if (n === 's1' && typeof h === 'string') h = h.replace(/(<span class="va-fp"><b>dès [^<]*<\/b>) les 2(?:&nbsp;|\s)semaines/g, '$1 les 6&nbsp;jours');
        return h;
      };
    });
    ['top', 's3', 'side', 'sum', 'go', 'note'].forEach(function(n){
      var f = A.R[n]; if (typeof f !== 'function') return;
      A.R[n] = function(S){
        var self = this, args = arguments;
        var h = noHw(S, function(){ return f.apply(self, args); });
        if (typeof h === 'string' && S && is6(S.dur)) {
          if (S.f && S.f.h === 'challenge-100-shakes') h = h.replace(/(<span>Livraison<\/span><span>)<span class="rd">Offerte<\/span>/, '$1<span>Non incluse, offerte dès 60&nbsp;€</span>');
          if (S.f && S.f.h === 'challenge-100-shakes') h = h.replace('<span>Livraison offerte</span>', '<span>Livraison non incluse, offerte dès 60&nbsp;€</span>');
          if (S.f && S.f.h === 'challenge-100-shakes') {
            h = h.replace(/<small>ou 3(?:&nbsp;| |\s)×[\s\S]*?<\/small>/g, '');
            h = h.replace(/Paiement en 3x ou 4x · sans abonnement/g, 'Sans abonnement');
            h = h.replace(/<div><svg(?:(?!<div>)[\s\S])*?<span>Paiement en 3x ou 4x<\/span><\/div>/g, '');
          }
          h = h.replace('Je commence mon Challenge · ', 'J’essaie 6 jours · ');
        }
        return h;
      };
    });
    D.addEventListener('click', function(ev){
      var b = ev.target.closest && ev.target.closest('[data-v34="more"]');
      if (!b) return;
      ev.preventDefault(); A.ui.v34more = 1; if (A.render) A.render(true);
    });
    D.addEventListener('click', function(ev){
      var b = ev.target.closest && ev.target.closest('[data-a="order"]');
      if (!b) return;
      var S = null; try { S = A.state && A.state(); } catch (x) {}
      var v = S && is6(S.dur) ? (wlMode() ? 'wl' : 'encadre') : '';
      function put(){ try { fetch('/cart/update.js', {method: 'POST', keepalive: true, headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {essai_6j: v}})}); } catch (x) {} }
      put(); setTimeout(put, 2500);
      if (v) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('so_essai_6j_ajout', {entree: v}); } catch (x) {} }
    }, true);
    return true;
  }

  var n = 0;
  (function tick(){
    try { syncRaw(); paintA(); } catch (x) {}
    var ok = false; try { ok = wrapB(); } catch (x) {}
    if (n++ < 60) setTimeout(tick, ok ? 1000 : 150);
  })();
})();